export default __webpack_public_path__ + "static/media/how-to-3.d835257c.png";